(function() {
  function initSwiper(swiperEl) {
    if (!swiperEl || typeof Swiper === 'undefined') return null;
    if (swiperEl.swiper) return swiperEl.swiper;

    const autoplayEnabled = swiperEl.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(swiperEl.dataset.autoplaySpeed, 10) || 4000;
    const pauseOnHover = swiperEl.dataset.pauseOnHover === 'true';

    const swiperConfig = {
      loop: autoplayEnabled ? true : false,
      grabCursor: true,
      spaceBetween: 16,
      slidesPerView: 'auto',
      breakpoints: {
        768: {
          spaceBetween: 24,
        },
      },
    };

    if (autoplayEnabled) {
      swiperConfig.autoplay = {
        delay: autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: pauseOnHover,
      };
    }

    return new Swiper(swiperEl, swiperConfig);
  }

  function initAllSwipers() {
    document.querySelectorAll('.ctr-listicle-testimonials__carousel').forEach((swiperEl) => {
      initSwiper(swiperEl);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSwipers);
  } else {
    initAllSwipers();
  }

  // Handle Shopify theme editor events
  document.addEventListener('shopify:section:load', (e) => {
    const swiperEl = e.target.querySelector('.ctr-listicle-testimonials__carousel');
    if (swiperEl) initSwiper(swiperEl);
  });
})();
